var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 9.99987L5.99996 7.99987M7.99996 9.99987C8.93116 9.64567 9.82456 9.199 10.6666 8.66653M7.99996 9.99987V13.3332C7.99996 13.3332 10.02 12.9665 10.6666 11.9999C11.3866 10.9199 10.6666 8.66653 10.6666 8.66653M5.99996 7.99987C6.35472 7.07947 6.80143 6.19721 7.33329 5.36651C8.11009 4.1245 9.19169 3.10187 10.4753 2.3959C11.7589 1.68993 13.2018 1.32409 14.6666 1.33317C14.6666 3.14651 14.1466 6.33317 10.6666 8.66653M5.99996 7.99987H2.66663C2.66663 7.99987 3.03329 5.97984 3.99996 5.33317C5.07996 4.61317 7.33329 5.33317 7.33329 5.33317M2.99996 10.9999C1.99996 11.8399 1.66663 14.3332 1.66663 14.3332C1.66663 14.3332 4.15996 13.9999 4.99996 12.9999C5.47329 12.4399 5.46663 11.5799 4.93996 11.0599C4.68083 10.8125 4.33949 10.6696 3.98145 10.6585C3.6234 10.6475 3.27388 10.769 2.99996 10.9999Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.b866e69d02ae0e7ebb3da98afda189b1.svg";
export { ForwardRef as ReactComponent };